// Vite provided environment variables
export const ENV_VITE_DEV = import.meta.env.DEV
export const ENV_VITE_BASE_PATH = import.meta.env.BASE_URL

// Custom environment variables
export const ENV_APP_VERSION = import.meta.env.VITE_APP_VERSION ?? 'N/A'
export const ENV_INTERNAL_BFF_URL =
  import.meta.env.VITE_INTERNAL_BFF_URL ?? 'NOT_FOUND_VITE_INTERNAL_BFF_URL'
export const ENV_INTERNAL_SIGNALR_URL =
  import.meta.env.VITE_INTERNAL_SIGNALR_URL ??
  'NOT_FOUND_VITE_INTERNAL_SIGNALR_URL'
export const ENV_ENABLE_DD_RUM = import.meta.env.VITE_ENABLE_DD_RUM

// Analytics
export const ENV_SEGMENT_WRITE_KEY =
  import.meta.env.VITE_SEGMENT_WRITE_KEY || ''
